// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__3vpM5","header":"ReportDetails_header__16M9Q","title":"ReportDetails_title__3Qo4D","left":"ReportDetails_left__2WqKn"};